<div class="container-sale" id="container-sale">
	<div id="title-page" class="card mb-3 title-page">
		<div class="row title-total">
			<div class="col-sm">
				<h4 style="font-weight: 900;margin:auto">Factura de Compra</h4>
			</div>
			<span class="col-sm totals-span" style="color: goldenrod;">
				Total de <b> Pago</b>
				<span id="total-paid"><ng-container *ngTemplateOutlet="currency;"></ng-container>
					{{ total | number:'1.0-4'}}</span>
			</span>
			<span class="col-sm totals-span text-success" [class.clickeable]="!saving" (click)="savePurchase()"
				*ngIf="total > 0 && inputs.warehouse.verified && inputs.client.verified && (((options.selected =='invoice' || options.selected =='administrative' ) && options.invoice.number && options.invoice.serie) || (options.selected=='receipt'))">
				<i *ngIf="!saving" class="fa fa-save"></i>
				<span *ngIf="saving" class="spinner-border spinner-border-sm" aria-hidden="true"></span>{{saving?'GUARDANDO':'GUARDAR'}}
			</span>
		</div>
	</div>
	<div class="card" id="invoice-data">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h3>1. Bodega, proveedor y datos de factura </h3>
		</div>
		<div class="card-body">
			<div class="">
				<div class="row">
					<div class="col-sm">
						<div id="warehouse-input-container" class="input-group input-group-sm mb-2">
							<label for="warehouse-input" class="input-group-text">Bodega
							</label>
							<button class="btn btn-primary btn-icon" type="button" data-bs-toggle="tooltip"
								data-bs-custom-class="custom-tooltip" data-bs-title="Crea una nueva bodega"
								data-bs-placement="top"><i class="bx bxs-plus-circle"
									(click)="creatingNewWarehouse = true"></i></button>
							<div class="btn-group" id="options-warehouse" class="options-toggle">
								<button type="button" class="btn btn-primary" data-bs-toggle="dropdown"
									aria-haspopup="true">
									<i class="bx bx-dots-vertical-rounded"></i>
								</button>
								<div class="dropdown-menu">
									<button class="dropdown-item">Crear bodega</button>
									<button class="dropdown-item">Listar bodegas</button>
								</div>
							</div>
							<app-input-autocomplete [allBorderRadius]="false" [inputs]="inputs.warehouse"
								[placeholder]="'Ingresa una bodega'" [filterElements]="filterWarehouses"
								[typeElements]="'warehouse'" (changeMethod)="verifiedInput($event.event,'warehouse')"
								(inputMethod)="handleInput($event.event,'warehouse')"
								(getTitle)="$event.filterElement.title = $event.filterElement.name"
								(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.name,1,'warehouse')"></app-input-autocomplete>
						</div>
						<div id="client-input-container" class="input-group input-group-sm mb-2">
							<label for="client-input" class="input-group-text">Proveedor <span
									style="color: transparent;">.</span></label>
							<app-input-autocomplete [allBorderRadius]="false" [inputs]="inputs.client"
								[placeholder]="'Ingresa un proveedor'" [filterElements]="filterClients"
								[typeElements]="'provider'"
								(inputMethod)="handleInput($event.event,'client')"
								(getTitle)="$event.filterElement.title = $event.filterElement.nit + ' - ' + $event.filterElement.name"
								(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.nit+' - '+$event.filterElement.name,1,'client')"></app-input-autocomplete>
						</div>
						<div class="row" *ngIf="showPolicy"> 
							<div class="col-sm">
								<div class="input-group mb-2">
									<label for="policy" class="input-group-text">Póliza</label>
									<div class="form-control d-flex justify-content-center align-items-center">
										<input type="checkbox" [(ngModel)]="inputs.policy" id="policy" name="policy"
											class="form-check-input" style="transform: scale(1.5);">
									</div>
								</div>
							</div>
						</div>		
						<div id="client-input-container" class="input-group input-group-sm mb-2" *ngIf="inputs.policy">
							<label for="client-input" class="input-group-text">Proveedor de Póliza <span
									style="color: transparent;">.</span></label>
							<app-input-autocomplete [allBorderRadius]="false" [inputs]="inputs.providerPolicy"
								[placeholder]="'Ingresa un proveedor para la póliza'" [filterElements]="filterProvidersPolicy"
								[typeElements]="'provider'"
								(inputMethod)="handleInput($event.event,'providerPolicy')"
								(getTitle)="$event.filterElement.title = $event.filterElement.nit + ' - ' + $event.filterElement.name"
								(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.nit+' - '+$event.filterElement.name,1,'providerPolicy')"></app-input-autocomplete>
						</div>
						<div class="row">
							<div class="col-sm">
								<div class="input-group input-group-sm mb-2">
									<label for="inputGroupSelect" class="input-group-text">Fecha</label>
									<input type="date" [(ngModel)]="inputs.date" (change)="getExchangeRate()" id="fecha" name="fecha"
										class="form-control">
								</div>
							</div>
							<div class="wrapper col-sm" *ngIf="inputs.policy">
								<div class="text" style="padding-right: 1rem; font-weight: bold;">Moneda</div>
								<input id="currency" name="currency" type="checkbox" (change)="dollar=!dollar">
								<label class="button" for="currency">
									<div class="dot"></div>
								</label>
								<div class="dollar-text">Dolar</div>
							</div>
						</div>
						<div class="input-group input-group-sm mb-2 mt-1">
							<label for="description" class="input-group-text">Observaciones</label>
							<textarea class="form-control" name="description"
								placeholder="Ingrese tus observaciones para esta factura de venta, tienes hasta 100 caracteres"
								id="description" [(ngModel)]="inputs.description" cols="30" rows="2"></textarea>
						</div>
					</div>
					<div class="col-sm">
						<div class="accordion" id="accordionExample">
							<div class="accordion-item" *ngIf="checkAdministration && loadingConfig">
								<div class="input-radio" [class.div-checked]="options.selected=='administrative'" id="administrative"
									(click)="options.selected='administrative'">
									<input id="inputInvoice" [(ngModel)]="options.selected" class="radioData"
										value="administrative" name="options" type="radio" checked>
									<span class="text-radio">Seleccione esta opción si emitió una factura. (Administrativa)</span>
								</div>
								<div class="showWithInput" [class.showInvoice]="options.selected=='administrative'">
									<div class="row">
										<div class="col-sm">
											<label for="serie" class="label-div-invoice">No. Serie <span
												class="required-field"><i class="fa fa-asterisk"></i></span></label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="serie" id="serie"
													placeholder="Ingrese número de serie"
													[(ngModel)]="options.invoice.serie">
											</div>
										</div>
										<div class="col-sm">
											<label for="factura" class="label-div-invoice">No. Factura <span
													class="required-field"><i class="fa fa-asterisk"></i></span></label>
											<div class="input-group input-group-sm mb-2">
												<input type="number" class="form-control" name="factura" id="factura"
													placeholder="Ingrese número de factura"
													[(ngModel)]="options.invoice.number">
											</div>
										</div>
										<div class="col-sm">
											<label for="discount" class="label-div-invoice">Descuento de dinero:</label>
											<div class="input-group input-group-sm mb-2">
												<input type="number" class="form-control" name="discount" id="discount"
													placeholder="0.00" [(ngModel)]="options.invoice.discount">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-item" *ngIf="!checkAdministration && loadingConfig">
								<div class="input-radio" [class.div-checked]="options.selected=='invoice'" id="invoice"
									(click)="options.selected='invoice'">
									<input id="inputInvoice" [(ngModel)]="options.selected" class="radioData"
										value="invoice" name="options" type="radio" checked>
									<span class="text-radio">Seleccione esta opción si emitió una factura</span>
								</div>
								<div class="showWithInput" [class.showInvoice]="options.selected=='invoice'">
									<div class="row">
										<div class="col-sm">
											<label for="serie" class="label-div-invoice">No. Serie <span
												class="required-field"><i class="fa fa-asterisk"></i></span></label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="serie" id="serie"
													placeholder="Ingrese número de serie"
													[(ngModel)]="options.invoice.serie">
											</div>
										</div>
										<div class="col-sm">
											<label for="factura" class="label-div-invoice">No. Factura <span
													class="required-field"><i class="fa fa-asterisk"></i></span></label>
											<div class="input-group input-group-sm mb-2">
												<input type="number" class="form-control" name="factura" id="factura"
													placeholder="Ingrese número de factura"
													[(ngModel)]="options.invoice.number">
											</div>
										</div>
										<div class="col-sm">
											<label for="discount" class="label-div-invoice">Descuento de dinero:</label>
											<div class="input-group input-group-sm mb-2">
												<input type="number" class="form-control" name="discount" id="discount"
													placeholder="0.00" [(ngModel)]="options.invoice.discount">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="accordion-item">
								<div class="input-radio" id="div-receipt"
									[class.div-checked]="options.selected=='receipt'"
									(click)="options.selected='receipt'">
									<input id="inputReceipt" class="radioData" [(ngModel)]="options.selected"
										value="receipt" name="options" type="radio">
									<span class="text-radio">Seleccione esta opción si emitió un recibo o un
										documento
										de pago</span>
								</div>
								<!-- <div class="showWithInput" [class.showInvoice]="options.selected=='receipt'">
									<div class="row">
										<div class="form-group col-sm">
											<label for="doc">No. Documento <span class="required-field"><i
														class="fa fa-asterisk"></i></span></label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="doc" id="doc"
													placeholder="Ingrese número de documento"
													[(ngModel)]="options.doc.number">
											</div>
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card mb-3 mt-2">
		<div id="card-header-products" class="card-header d-flex justify-start gap-2 items-center">
			<h3>2. Agregar Productos </h3>
			<!-- <span
				(click)="showOC = !showOC"
				class="a-hover"
				style="font-size: 1em; cursor: pointer;"
				tooltip="Ver OC"
				*ngIf="inputs.warehouse.verified && inputs.client.verified"
			>
				<span  *ngIf="!showOC">
					<i class="fa fa-eye span-hovern text-info"></i> Ver OC
				</span>
				<span  *ngIf="showOC">
					<i class="fa fa-eye-slash span-hover text-info"></i> Ocultar OC
				</span>
			</span> -->
		</div>
		<!-- <div class="d-grid grid-cols-2">
			<div class="pr-2" *ngIf="showOC">
				<div class="row" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Filtrar</label>
						<div class="input-group input-group-sm">
							<input
								type="text"
								id="filter"
								[(ngModel)]="filterWordOrders"
								(input)="onInputChangeOrder($event)"
								placeholder="Filtra pedidos por usuario o bodega"
								name="filter"
								class="form-control"
							/>
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
			
				<div class="table-responsive mb-4" style="margin-bottom: 0; overflow-y: inherit; max-height: none; overflow-x: auto;" *ngIf="showOC">
				<table class="table table-striped">
					<thead>
						<tr>
							<th class="ta">Número</th>
							<th class="text-center">Fecha Solicitado</th>
							<th class="text-center">Fecha Esperada</th>
							<th class="ta">Proveedor</th>
							<th class="text-center">Acciones</th>
						</tr>
					</thead>
					<tbody>
							<ng-container *ngFor="let order of paginationOrders.filter">
								<tr>
									<td>{{ order.number }}</td>
									<td class="text-center">
										{{
											formatDate(order.creationDate)
												| date : "dd/MM/yyyy"
										}}
									</td>
									<td class="text-center">
										{{
											formatDate(order.deliveryDate)
												| date : "dd/MM/yyyy"
										}}
									</td>
									<td>
										{{
											order.providerData
												? order.providerData.name
												: "Desconocido"
										}}
									</td>
									<td class="">
										<div class="d-flex justify-center items-center gap-2">
											<span class="a-hover" tooltip="Ver Detalles" (click)="showDetails(order)">
												<i class="fa fa-eye span-hover text-primary"></i>
											</span>
											<span class="a-hover" tooltip="Agregar Productos" (click)="addProductsOrder(order)">
												<i class="fa fa-plus-circle span-hover text-success"></i>
											</span>
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="paginationOrders.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se tienen
									pedidos
								</td>
							</tr>
						</tbody>
				</table>
				<app-pagination-custom [elements]="paginationOrders"></app-pagination-custom>
				</div>
			</div>
			<div class="table-responsive mb-4 pl-2 pt-2" *ngIf="showOC">
				<div class="mt-4">
					<label for="filterVendors" class="form-label font-bold">DETALLES DE ORDEN: <span *ngIf="currentOrder">{{currentOrder.number}}</span></label>
				</div>
				<table class="table table-striped">
					<thead>
						<tr>
							<th class="ta">Producto</th>
							<th class="ta">Cantidad</th>
							<th class="ta">Precio</th>
							<th class="ta">Total</th>
							<th class="ta">Estado</th>
						</tr>
					</thead>
					<tbody>
							<ng-container *ngFor="let order of purchaseDetailsOrder">
								<tr>
									<td class="ta">
										{{ order.productData.name}}
									</td>
									<td class="ta">
										{{order.quantity}}
									</td>
									<td class="ta">
										{{order.cost}}
									</td>
									<td class="ta">
										Q {{(order.quantity*order.cost).toFixed(2)}}
									</td>
									<td class="ta">
										<span *ngIf="order.statusType==1" class="text-success font-bold">
											COMPLETADO
										</span>
										<span *ngIf="order.statusType==2" class="text-warning font-bold">
											PARCIALMENTE COMPLETADO
										</span>
										<span *ngIf="order.statusType==3" class="text-danger font-bold">
											EN ESPERA
										</span>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="purchaseDetailsOrder && purchaseDetailsOrder.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se tienen
									detalles
								</td>
							</tr>
						</tbody>
				</table>
			</div>
		</div> -->
		<div class="card-body">
			<div class="row">
				<div id="product-div" class="col-sm table-toggle">
					<div class="row">
						<div class="col-sm">
							<div class="form-group">
								<label for="producto">Producto/Servicio
								</label>
								<div class="input-group input-group-sm">
									<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.product"
										[placeholder]="'Ingresa el código de barras, id o nombre de un producto'"
										[filterElements]="filterProducts" [typeElements]="'product'"
										(changeMethod)="verifiedInput($event.event,'product')"
										(inputMethod)="handleInput($event.event,'product')"
										(getTitle)="$event.filterElement.title = (($event.filterElement.code)?$event.filterElement.code + ' - ':'')+ $event.filterElement.name"
										[ruleToDisabled]="!inputs.warehouse.verified || !inputs.client.verified"
										(changeStatus)="changeStatusInput($event.filterElement,($event.filterElement.code?$event.filterElement.code+' - ':'')+$event.filterElement.name,1,'product')"></app-input-autocomplete>
								</div>
								<div *ngIf="!inputs.warehouse.verified || !inputs.client.verified"
									class="form-text text-danger">Ingresa una bodega y
									cliente primero</div>
							</div>
							<ng-container *ngIf="inputs.warehouse.verified && inputs.client.verified">
								<div class="plus-data">
									<div class="input-group input-group-sm first-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="mount" class="input-group-text">Cantidad</label>
										<input type="number" [(ngModel)]="searchProduct.quantity" value="1"
											class="form-control" name="ammount" id="ammount"
											(ngModelChange)="searchProduct.total = searchProduct.quantity * searchProduct.price"
											[disabled]="!inputs.product.verified">
									</div>
									<div class="input-group input-group-sm rest-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="price" class="input-group-text">Precio</label>
										<div class="exception">
											<input type="number" [(ngModel)]="searchProduct.price" value="0"
												class="form-control" name="price" id="price"
												[disabled]="searchProduct.prices.length > 0"
												(ngModelChange)="searchProduct.total = searchProduct.quantity * searchProduct.price"
												[disabled]="!inputs.product.verified">
											<div class="btn-group btn-group-sm" *ngIf="searchProduct.prices.length > 0">
												<button class="btn btn-primary dropdown-toggle" type="button"
													data-bs-toggle="dropdown" data-bs-auto-close="true"
													aria-expanded="false">
													<i class="fa fa-tags"></i>
												</button>
												<ul class="dropdown-menu">
													<li *ngFor="let optionPrice of searchProduct.prices">
														<a class="dropdown-item"
															(click)="searchProduct.price = optionPrice.price; searchProduct.total = searchProduct.quantity * searchProduct.price;">{{optionPrice.listData.name}}
															- {{optionPrice.price}}</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div class="input-group input-group-sm rest-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="total" class="input-group-text">Total</label>
										<input type="number" [(ngModel)]="searchProduct.total" class="form-control"
											name="total" id="total" disabled value="0">
									</div>
								</div>
								<button class="btn btn-primary btn-product" type="button"
									[disabled]="searchProduct.price <= 0 || searchProduct.quantity <= 0"
									id="add-product" (click)="addProduct(null)">Agregar
									<i class="fa fa-cart-plus"></i>
								</button>
							</ng-container>
						</div>
					</div>
					<div *ngIf="productsList.length>0" id="miDiv" class="table-container table-responsive">
						<table class="table table-striped" id="table-height">
							<thead>
								<tr>
									<th>#</th>
									<th>Imagen</th>
									<th>Producto</th>
									<th>Cantidad</th>
									<th>Precio Unidad</th>
									<th>Total</th>
									<th>Opciones</th>
								</tr>
							</thead>
							<tbody class="table-group-divider">
								<tr *ngFor="let product of productsList; let i = index" class="row-product"
									id="p{{product.code}}">
									<td>{{i+1}}</td>
									<td>
										<div class="th-center">
											<img src="{{product.data.image?product.data.image:'../../../../../assets/img/nophoto.svg'}}"
												alt="Sin foto" class="no-photo"
												(error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
										</div>
									</td>
									<td>
										<span class="product-name text-info" *ngIf="!product.nameEditing"
											(click)="product.nameEditing = true">
											{{product.name}}
											<i class="show-hover bx bxs-edit-alt"></i>
										</span>
										<div class="input-group input-group-sm" *ngIf="product.nameEditing">
											<input type="text" [(ngModel)]="product.name" class="form-control">
											<button class="btn btn-primary" (click)="product.nameEditing = false"
												style="border-top-right-radius: var(--bs-border-radius); border-bottom-right-radius: var(--bs-border-radius);">
												<i class="bx bxs-save"></i> </button>
										</div>
									</td>
									<td><input class="form-control" id="m{{product.id}}" type="number"
											[(ngModel)]="product.quantity" (input)="changeValue(product,'ammount')">
									</td>
									<td><input class="form-control" id="pr{{product.id}}" type="number"
											[(ngModel)]="product.price" (input)="changeValue(product,'price')">
									</td>
									<td><ng-container *ngTemplateOutlet="currency;"></ng-container>.
										{{product.total | number:'1.0-4'}}</td>
									<td>
										<div class="th-center">
											<div class="flex-td" *ngIf="product.data.exemptTextId!=0">
												<label for="exempt{{product.id}}">¿Exento?</label>
												<input type="checkbox" id="exempt{{product.id}}"
													name="exempt{{product.id}}" [(ngModel)]="product.canBeExempt">
											</div>
											<span class="clickeable text-danger" (click)="deleteProduct(product.id)">
												<i class="fa fa-trash"></i>
											</span>
										</div>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="5">Total</td>
									<td><ng-container *ngTemplateOutlet="currency;"></ng-container>.
										{{total | number:'1.0-4'}}</td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="row mt-2" *ngIf="total>0">
						<div class="col">
							<button class="btn btn-success" (click)="savePurchase()" style="width: 100%;"
								[disabled]="saving || !(total > 0 && inputs.warehouse.verified && inputs.client.verified && (((options.selected =='invoice' || options.selected =='administrative') && options.invoice.number && options.invoice.serie) || (options.selected=='receipt')))">
								<i *ngIf="!saving" class="fa fa-save"></i>
								<span *ngIf="saving" class="spinner-border spinner-border-sm"
									aria-hidden="true"></span>{{saving?'GUARDANDO':'GUARDAR'}}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #currency>
	<i [class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i>
</ng-template>
<app-success-modal *ngIf="success!=''" [message]="success"></app-success-modal>